import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Input } from "design-react-kit";
import React, { useContext, useState, useEffect } from "react";

function SubscriptionDetail({
  userSubscriptions,
  toggleModalShowFile,
  toggleModalAdd,
  setFile,
  setFileSettings,
  setshowModalModify,
  isOperator,
  toggleModalPunteggio,
  totaleScore,
  toggleModalAddHours,
  setShowModalOtherServices,
}) {
  const [otherService, setOtherService] = useState([]);
  const [firstTime, setFirstTime] = useState(true);

  useEffect(() => {
    if (firstTime && userSubscriptions?.otherServices) {
      setOtherService(
        userSubscriptions?.otherServices
          ? userSubscriptions?.otherServices?.split("/;/")
          : [],
      );
    }
    setFirstTime(false);
  }, [userSubscriptions?.otherServices]);

  return (
    <>
      <div className="row no_print">
        <div className="col-lg-12 mt-3">
          <div className="card-wrapper card-space">
            <div className="card card-bg no-after card-big roundedCustom">
              <div className="card-body">
                <h4>Contratto</h4>
                {isOperator ? (
                  <>
                    {userSubscriptions?.state === "ADDED" && (
                      <div className="alert alert-info mt-2">
                        In Attesa del caricamento dell'atto firmato da parte
                        dell'utente.
                      </div>
                    )}
                    {userSubscriptions?.state === "LOADED" && (
                      <div className="row align-items-center justify-content-center mb-4">
                        <button
                          type="button"
                          className="btn btn-primary text-success w-50 p-2 py-3"
                          onClick={() => {
                            setshowModalModify(true);
                          }}
                        >
                          <svg className="icon icon-white">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>{" "}
                          <span className="align-middle text-white">
                            Esito Valutazione
                          </span>
                        </button>
                      </div>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                        </div>
                        <div className="row">
                          {userSubscriptions?.orePreviste && (
                            <div className="col-2">
                              Ore previste:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.orePreviste}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.dataInizio && (
                            <div className="col-5">
                              Periodo di validità: dal
                              <strong className="mx-1">
                                {userSubscriptions?.dataInizio}
                              </strong>
                              {userSubscriptions?.dataFine && (
                                <>
                                  al
                                  <strong className="ml-1">
                                    {userSubscriptions?.dataFine}
                                  </strong>
                                </>
                              )}
                            </div>
                          )}
                          {userSubscriptions?.nProtocollo && (
                            <div className="col-2">
                              N. Protocollo:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocollo}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                          <div className="col text-right">
                            <button
                              type="button"
                              className="btn btn-outline-primary text-success  p-2"
                              onClick={() => {
                                setshowModalModify(true);
                              }}
                              title="Modifica iscrizione"
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {" "}
                    {userSubscriptions?.state === "ADDED" && (
                      <div className="alert alert-info mt-2">
                        Per procedere con la revisione dell'iscrizione, è
                        necessario caricare l'atto firmato e stabilire il
                        punteggio di gravità.
                      </div>
                    )}{" "}
                    {userSubscriptions?.state === "LOADED" && (
                      <div className="alert alert-info mt-2">
                        In Attesa di revisione da parte dell'ufficio di piano
                      </div>
                    )}
                    {userSubscriptions?.state === "VALIDATED" && (
                      <div className="alert alert-success mt-2">
                        <div className="row">
                          <strong>Validato</strong>
                        </div>
                        <div className="row">
                          {userSubscriptions?.orePreviste && (
                            <div className="col-2">
                              Ore previste:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.orePreviste}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.dataInizio && (
                            <div className="col-5">
                              Periodo di validità: dal
                              <strong className="mx-1">
                                {userSubscriptions?.dataInizio}
                              </strong>
                              {userSubscriptions?.dataFine && (
                                <>
                                  al
                                  <strong className="ml-1">
                                    {userSubscriptions?.dataFine}
                                  </strong>
                                </>
                              )}
                            </div>
                          )}
                          {userSubscriptions?.nProtocollo && (
                            <div className="col-2">
                              N. Protocollo:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocollo}
                              </strong>
                            </div>
                          )}
                          {userSubscriptions?.nProtocolloUscita && (
                            <div className="col-3">
                              N. Protocollo Uscita:{" "}
                              <strong className="ml-1">
                                {userSubscriptions?.nProtocolloUscita}
                              </strong>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
                <div className="container mb-5">
                  <div className="row row-cols-2">
                    {userSubscriptions &&
                    userSubscriptions.subscriptionFiles.filter(
                      (x) => x.description === "fileDaFirmare",
                    ).length > 0 ? (
                      userSubscriptions.subscriptionFiles
                        .filter((x) => x.description === "fileDaFirmare")
                        .map((allegato, index) => (
                          <React.Fragment key={index}>
                            <div className="col border-right">
                              <div className="categoryicon-top">
                                <span className="text">
                                  <a
                                    href="#"
                                    className="text-decoration-none font-weight-bold"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setFile({
                                        data:
                                          "data:application/pdf;base64," +
                                          allegato?.storageFile?.file,
                                      });
                                      toggleModalShowFile(true);
                                    }}
                                  >
                                    <svg className="icon">
                                      <use href={`${iconSprite}#it-clip`}></use>
                                    </svg>
                                    {allegato.storageFile.name}
                                  </a>

                                  <br />
                                </span>
                              </div>

                              <p className="card-text font-serif">
                                {allegato.description === "fileDaFirmare" ? (
                                  <>Atto da firmare</>
                                ) : (
                                  <></>
                                )}
                              </p>
                            </div>
                            {userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "fileFirmato",
                            ).length > 0 ? (
                              <>
                                {userSubscriptions.subscriptionFiles
                                  .filter(
                                    (x) => x.description === "fileFirmato",
                                  )
                                  .map((allegatoFirmato, index) => (
                                    <div className="col" key={index}>
                                      <div className="row">
                                        <div className="col-11">
                                          <div className="categoryicon-top">
                                            <span className="text">
                                              <a
                                                href="#"
                                                className="text-decoration-none font-weight-bold"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setFile({
                                                    data:
                                                      "data:application/pdf;base64," +
                                                      allegatoFirmato
                                                        ?.storageFile?.file,
                                                  });
                                                  toggleModalShowFile(true);
                                                }}
                                              >
                                                <svg className="icon">
                                                  <use
                                                    href={`${iconSprite}#it-clip`}
                                                  ></use>
                                                </svg>
                                                {
                                                  allegatoFirmato.storageFile
                                                    .name
                                                }
                                              </a>

                                              <br />
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-1">
                                          <button
                                            type="button"
                                            className={
                                              userSubscriptions?.state ===
                                              "VALIDATED"
                                                ? "border btn btn-outline-primary text-success  p-2"
                                                : "btn btn-outline-primary text-success  p-2"
                                            }
                                            onClick={() => {
                                              toggleModalAdd(true);
                                              setFileSettings({
                                                title: "Atto Firmato",
                                                description: "fileFirmato",
                                                fileName: "Atto_Firmato",
                                              });
                                            }}
                                            aria-label="Carica atto firmato"
                                            disabled={
                                              userSubscriptions?.state ===
                                              "VALIDATED"
                                            }
                                            title={
                                              userSubscriptions?.state ===
                                              "VALIDATED"
                                                ? "Non si possono apportare modifiche alle iscrizioni validate"
                                                : "Sovrascrivi atto firmato"
                                            }
                                          >
                                            <svg className="icon icon-primary">
                                              <use
                                                href={`${iconSprite}#it-upload`}
                                              />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>

                                      <p className="card-text font-serif ms-1">
                                        {allegatoFirmato.description ===
                                        "fileFirmato" ? (
                                          <>Atto Firmato</>
                                        ) : (
                                          <>{allegatoFirmato.description}</>
                                        )}
                                      </p>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="col align-self-center text-center">
                                <button
                                  type="button"
                                  className={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "border btn btn-outline-primary text-success  p-2"
                                      : "btn btn-outline-primary text-success  p-2"
                                  }
                                  onClick={() => {
                                    toggleModalAdd(true);
                                    setFileSettings({
                                      title: "Atto Firmato",
                                      description: "fileFirmato",
                                      fileName: "Atto_Firmato",
                                    });
                                  }}
                                  disabled={
                                    userSubscriptions?.state === "VALIDATED"
                                  }
                                  title={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                      : "Carica atto firmato"
                                  }
                                >
                                  <svg className="icon icon-primary">
                                    <use href={`${iconSprite}#it-upload`} />
                                  </svg>{" "}
                                  <span className="align-middle">
                                    Carica atto firmato
                                  </span>
                                </button>
                              </div>
                            )}
                          </React.Fragment>
                        ))
                    ) : (
                      <>Non ci sono contratti.</>
                    )}

                    <div className="col text-center border-right mt-4">
                      <h4 className="mr-5">Punteggio di gravità*</h4>
                      <div className="col">
                        <div className="row">
                          <div className="col-10 text-center">
                            <div className="row">
                              <div className="col-7 mt-2 offset-lg-3">
                                <Input
                                  id="rankingScore"
                                  disabled
                                  label="Punteggio"
                                  type="text"
                                  value={totaleScore?.toString()}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-2 pl-4 mt-2">
                            <button
                              type="button"
                              className={
                                userSubscriptions?.state === "VALIDATED"
                                  ? "border btn btn-outline-primary text-success  p-2"
                                  : "btn btn-outline-primary text-success  p-2"
                              }
                              onClick={() => {
                                toggleModalPunteggio(true);
                              }}
                              disabled={
                                userSubscriptions?.state === "VALIDATED"
                              }
                              title={
                                userSubscriptions?.state === "VALIDATED"
                                  ? "Non si possono apportare modifiche alle iscrizioni validate"
                                  : "Modifica punteggio di gravità"
                              }
                            >
                              <svg className="icon icon-primary">
                                <use href={`${iconSprite}#it-pencil`} />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col text-center mt-4">
                      <h4>Monte ore stabilito</h4>
                      <div className="row">
                        <div className="col-11 text-center">
                          <div className="row">
                            <div className="col-4"></div>
                            <div className="col-5 mt-2">
                              <Input
                                id="orePreviste"
                                disabled
                                label="Ore previste"
                                type="text"
                                value={userSubscriptions.orePreviste}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-1 mt-2">
                          <button
                            type="button"
                            className={
                              userSubscriptions?.state === "VALIDATED"
                                ? "border btn btn-outline-primary text-success  p-2"
                                : "btn btn-outline-primary text-success  p-2"
                            }
                            onClick={() => {
                              toggleModalAddHours(true);
                            }}
                            disabled={userSubscriptions?.state === "VALIDATED"}
                            title={
                              userSubscriptions?.state === "VALIDATED"
                                ? "Non si possono apportare modifiche alle iscrizioni validate"
                                : "Modifica ore stabilite dell'equipe medica"
                            }
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-pencil`} />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col text-center border-right mt-4">
                      <h4>Altre misure di sostegno:</h4>
                      <div className="row">
                        <div className="col-10">
                          {otherService?.length > 0 ? (
                            <ul>
                              <div className="row">
                                {otherService.map((service, index) => (
                                  <li key={index} className="col-12 text-left">
                                    {service}
                                  </li>
                                ))}
                              </div>
                            </ul>
                          ) : (
                            <div>Nessuna misura di sostegno presente</div>
                          )}
                        </div>
                        <div className="col-2 pl-4 ">
                          <button
                            type="button"
                            className={
                              userSubscriptions?.state === "VALIDATED"
                                ? "border btn btn-outline-primary text-success  p-2"
                                : "btn btn-outline-primary text-success  p-2"
                            }
                            onClick={() => {
                              setShowModalOtherServices(true);
                            }}
                            disabled={userSubscriptions?.state === "VALIDATED"}
                            title={
                              userSubscriptions?.state === "VALIDATED"
                                ? "Non si possono apportare modifiche alle iscrizioni validate"
                                : "Modifica le misure di sostegno di cui il richiedente beneficia"
                            }
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-pencil`} />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col text-center mt-4">
                      {(!isOperator &&
                        userSubscriptions.subscriptionFiles.some(
                          (x) => x.description === "istruttoriaFile",
                        ) > 0) ||
                        (isOperator && (
                          <>
                            <h4>Istruttoria</h4>
                            {userSubscriptions.subscriptionFiles.filter(
                              (x) => x.description === "istruttoriaFile",
                            ).length > 0 ? (
                              <>
                                {userSubscriptions.subscriptionFiles
                                  .filter(
                                    (x) => x.description === "istruttoriaFile",
                                  )
                                  .map((allegatoFirmato, index) => (
                                    <div key={index}>
                                      <div className="row">
                                        <div
                                          className={
                                            isOperator ? "col-11" : "col-12"
                                          }
                                        >
                                          <div className="categoryicon-top">
                                            <span className="text">
                                              <a
                                                href="#"
                                                className="text-decoration-none font-weight-bold"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setFile({
                                                    data:
                                                      "data:application/pdf;base64," +
                                                      allegatoFirmato
                                                        ?.storageFile?.file,
                                                  });
                                                  toggleModalShowFile(true);
                                                }}
                                              >
                                                <svg className="icon">
                                                  <use
                                                    href={`${iconSprite}#it-clip`}
                                                  ></use>
                                                </svg>
                                                {
                                                  allegatoFirmato.storageFile
                                                    .name
                                                }
                                              </a>

                                              <br />
                                            </span>
                                          </div>
                                        </div>
                                        {isOperator && (
                                          <div className="col-1">
                                            <button
                                              type="button"
                                              className={
                                                userSubscriptions?.state ===
                                                "VALIDATED"
                                                  ? "border btn btn-outline-primary text-success  p-2"
                                                  : "btn btn-outline-primary text-success  p-2"
                                              }
                                              onClick={() => {
                                                toggleModalAdd(true);
                                                setFileSettings({
                                                  title: "Istruttoria",
                                                  description:
                                                    "istruttoriaFile",
                                                  fileName: "Istruttoria",
                                                });
                                              }}
                                              aria-label="Carica Istruttoria"
                                              disabled={
                                                userSubscriptions?.state ===
                                                "VALIDATED"
                                              }
                                              title={
                                                userSubscriptions?.state ===
                                                "VALIDATED"
                                                  ? "Non si possono apportare modifiche alle iscrizioni validate"
                                                  : "Sovrascrivi Istruttoria"
                                              }
                                            >
                                              <svg className="icon icon-primary">
                                                <use
                                                  href={`${iconSprite}#it-upload`}
                                                />
                                              </svg>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="col align-self-center text-center">
                                <button
                                  type="button"
                                  className={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "border btn btn-outline-primary text-success  p-2"
                                      : "btn btn-outline-primary text-success  p-2"
                                  }
                                  onClick={() => {
                                    toggleModalAdd(true);
                                    setFileSettings({
                                      title: "Istruttoria",
                                      description: "istruttoriaFile",
                                      fileName: "Istruttoria",
                                    });
                                  }}
                                  disabled={
                                    userSubscriptions?.state === "VALIDATED"
                                  }
                                  title={
                                    userSubscriptions?.state === "VALIDATED"
                                      ? "Non si possono apportare modifiche alle iscrizioni validate"
                                      : "Carica Istruttoria"
                                  }
                                >
                                  <svg className="icon icon-primary">
                                    <use href={`${iconSprite}#it-upload`} />
                                  </svg>{" "}
                                  <span className="align-middle">
                                    Carica Istruttoria
                                  </span>
                                </button>
                              </div>
                            )}
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionDetail;
